import { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { useMatchMedia } from 'App/Header/useMatchMedia';
import {
	areSiblings,
	calcLogoOverlapBreakpoint,
	computeImageDimensions,
	ImageDimensions,
} from 'App/Header/util';
import { useLoadableResourceContext } from 'Workspace/ResourceProvider';
const citrixWorkSpaceLogo = require('css/img/citrix-workspace-logo.svg');

export const useLogoCompressionBreakpoint = (searchBarWidth = 360) => {
	const theme = useTheme();
	const logoURL = theme?.branding?.links?.HeaderLogoUrl;
	const chosenLogo = logoURL || citrixWorkSpaceLogo;
	const [overlapBreakpoint, setOverlapBreakpoint] = useState<number | null>(null);
	const [compressedDims, setCompressedDims] = useState<ImageDimensions | null>(null);
	const isBelowBreakpoint = useMatchMedia(`(max-width: ${overlapBreakpoint}px)`);
	const { value: resourceContext } = useLoadableResourceContext();

	useEffect(() => {
		const isResourcesLoaded = !!resourceContext?.resources;
		const searchBarElement = document.getElementById('search-module');
		const logoElement = document.getElementById('workspace-logo-link');
		if (!isResourcesLoaded && !areSiblings(searchBarElement, logoElement)) {
			return;
		}
		const initializeLogoBreakpoint = async () => {
			const breakpoint = await calcLogoOverlapBreakpoint(chosenLogo, searchBarWidth);
			setOverlapBreakpoint(breakpoint);
		};
		initializeLogoBreakpoint();
	}, [chosenLogo, searchBarWidth, resourceContext]);

	useEffect(() => {
		if (!overlapBreakpoint) {
			return;
		}
		async function shouldCompress() {
			if (isBelowBreakpoint) {
				const compressed = await computeImageDimensions(chosenLogo);
				setCompressedDims(compressed);
			} else {
				setCompressedDims(null);
			}
		}
		shouldCompress();
	}, [isBelowBreakpoint, chosenLogo, overlapBreakpoint]);

	return { isBelowBreakpoint, compressedDims };
};
